<app-edit-vehicle-options
  *ngIf="!isPlateToVinSection"
  [vehicle]="workingVehicle$ | async"
  [isActive]="true"
></app-edit-vehicle-options>
